import { render, staticRenderFns } from "./AuthOneTimeLogin.vue?vue&type=template&id=0a312214&"
import script from "./AuthOneTimeLogin.vue?vue&type=script&lang=js&"
export * from "./AuthOneTimeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a312214')) {
      api.createRecord('0a312214', component.options)
    } else {
      api.reload('0a312214', component.options)
    }
    module.hot.accept("./AuthOneTimeLogin.vue?vue&type=template&id=0a312214&", function () {
      api.rerender('0a312214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/auth/screens/AuthOneTimeLogin.vue"
export default component.exports